module.exports = __webpack_public_path__ + "76fbdcbe761cc68c5e023803c84296bc.pdf";